const resumeApprovalServiceName = "/Approval";

export function resumeApprovalService(http) {
    return {
        getPersonnelResumeForApprovalAsync: async (userId, excelExport = false) => {
            const data = {
                userId,
                excelExport
            }
            return await http.post(resumeApprovalServiceName + "/GetPersonnelResumeForApprovalAsync", data)
        }, 
           
        // getAllTimesheetConfirmations: async (query, personnelCode, year, month, check, excelExport = false) => {        
        //     const data = {
        //         JSONString: query,
        //         Year: year,
        //         Month: month,
        //         PersonnelCode: personnelCode,
        //         Check: check,
        //         excelExport
        //     }
        //     return await http.post(resumeApprovalServiceName + "/GetAllTimesheetConfirmations", data)
        // },
        // getAllTimesheetConfirmationsExcelExport: async (query, personnelCode, year, month, check, excelExport = false) => {
        //     const data = {
        //         JSONString: query,
        //         Year: year,
        //         Month: month,
        //         PersonnelCode: personnelCode,
        //         Check: check,
        //         excelExport
        //     }

        //     return await http.post(resumeApprovalServiceName + "/GetAllTimesheetConfirmationsOutputExcel", data,
        //     { responseType: "blob" });
        // },        
        // approveTimesheetDataItems : (selectedUsersList) => {
        //     //     const dataParams = {
        //     //     activityCode, 
        //     //     activityDescription, 
        //     //     activityDiscipline, 
        //     //     basic, 
        //     //     batchProcessingItem, 
        //     //     confirmedOvertime,
        //     //     costCenterCode, 
        //     //     fullName, 
        //     //     hasDirectorManagerApprived, 
        //     //     hasFirstApproved, 
        //     //     hasSecondApproved,
        //     //     id, 
        //     //     mission, 
        //     //     overTime, 
        //     //     personnelCode
        //     // };

        //     return http.post(resumeApprovalServiceName + "/ApproveSelectedTimesheetItems", selectedUsersList)
        // }
    }
}
